import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { User } from '../model/user';
import { UserBasicInfo } from '../../wino-shared/model/user-basic-info';
import { Observable, Subject, of, lastValueFrom} from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { WinoCookieService } from '../../wino-shared/services/wino-cookie.service';
import { BackendValidator } from '../../wino-shared/model/backend-validator';
import { HttpErrorHandler } from '../../wino-shared/utilities/http-error-handler';
import { environment } from 'src/environments/environment';
import { Permission } from '../../wino-shared/model/permission';
import { TokenOutsiderInfo } from '../model/token-outsider-info';
import { UserInfo } from '../../wino-shared/model/user-info';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

 private baseUrl = environment.membershipBackendAddress + '/api/user';

 public static permissions: Array<Permission> = new Array<Permission>();

 nicknameBusy: Subject<BackendValidator> = new Subject<BackendValidator>();
 emailBusy: Subject<BackendValidator> = new Subject<BackendValidator>();

 //private accountSubject: BehaviorSubject<User> | undefined;

  constructor(private httpClient: HttpClient, private cookieService: WinoCookieService, private errorHandler: HttpErrorHandler) { }

  registerUser(user: User): Observable<boolean> {

    let registeredUser: User;
    let userRegistered: Observable<boolean>;
    userRegistered =  this.httpClient.post<User>(`${this.baseUrl}/signup`, user).pipe(map( () => {
    /********** registeredUser = data; *************/
      return true;
    }), catchError( error => {
      if (error.error.validator !== undefined) {

        const validator: BackendValidator = error.error.validator;

        switch (validator.code) {
          case "nickname_busy":
            this.nicknameBusy.next(validator);
            console.log("Backend validator: " + validator.code);
            break;
          case "email_busy":
            this.emailBusy.next(validator);
            console.log("Backend validator: " + validator.code);
            break;
          default:
            console.log(
              `Found a validator error, but finished in default switch control flow...` + 
              `Backend returned status error ${error.error.status}.\n` +
              `Message is: ${error.error.message}`);
            console.log("Root cause: " + error.error.errors);
            console.log("Validator: " + error.error.validator);
        }
        throw new error(`Backend returned ${error.error.status} with message: ${error.error.message}`);
      } else {
        this.errorHandler.handleError(error, "AuthService");
        throw new error(`Backend returned ${error.error.status} with message: ${error.error.message}`);
      }
      /************* return of(false); ************/
    }));
    return userRegistered;
  }

    loginUser(userInfo: UserBasicInfo, stayLogged: boolean): Observable<UserInfo> {
        console.log("LOGIN USER... USER INFO: " + userInfo.id + ", " + userInfo.nickname + ", " + 
        "userInfo.password" + ", " + userInfo.email);

        this.cookieService.logout();

        return this.httpClient.post<UserInfo>(`${this.baseUrl}/signin/${stayLogged}`, userInfo);
        //{userRepresentation: user, externalToken: user.getExternalAccessToken(), origin: user.enumAuthOrigin});
    }

    logoutUser(): Observable<boolean> {
        
        this.cookieService.logout();
        return this.httpClient.get<boolean>(`${this.baseUrl}/signout`);
    }

    facebookLoginUser(): void {

        this.httpClient.get<string>(`${this.baseUrl}/facebookLogin`).subscribe(data => {

            //console.log("called " +  `${this.baseUrl}/facebookLogin`);
            const stringToken: string = JSON.stringify(data);
            const jsonObject = JSON.parse(stringToken);

            console.log("FACEBOOK LOGIN: " + stringToken);

            let uriCookieName = 'landing_uri';
            let uriCookieValue = environment.oauth2LandingUri;
            let scopeCookieName = 'scope';
            let scopeCookieValue = "instagramToken";

            let myDate = new Date();
            
            myDate.setMonth(myDate.getMonth() + 12);
            
            document.cookie = ( uriCookieName +"=" + uriCookieValue +
                ";expires=" + myDate + ";path=/" + ";domain=" + environment.membershipBackendHost);
            document.cookie = ( scopeCookieName +"=" + scopeCookieValue +
                ";expires=" + myDate + ";path=/" + ";domain=" + environment.membershipBackendHost);

            let facebookUrl: string = `${jsonObject.login_url}?client_id=${jsonObject.client_id}&redirect_uri=${jsonObject.redirect_uri}&state=${jsonObject.state}&scope=${jsonObject.scope}`;

            console.log("FACEBOOK URL: " + facebookUrl);
            console.log("COOKIES: " + document.cookie);

            window.open(facebookUrl);
            //window.location.href = (facebookUrl);

            /************************************************************
            let facebookParams: HttpParams = new HttpParams()
                .set("client_id", jsonObject.client_id)
                .set('redirect_uri', jsonObject.redirect_uri)
                .set("state", jsonObject.state)
                .set('scope', jsonObject.scope);
            this.httpClient.get(jsonObject.login_url, {params: facebookParams}).subscribe();
             ***************************************************************/
        });
    }

    changeUserPassword(userBasicInfo: UserBasicInfo): Promise<boolean> {
        return lastValueFrom(this.httpClient.put<boolean>(`${this.baseUrl}/password`, userBasicInfo));
    }

    updateInstagramNickname(userBasicInfo: UserBasicInfo): Promise<UserBasicInfo> {
        return lastValueFrom(this.httpClient.put<UserBasicInfo>(`${this.baseUrl}/instagramNickname`, userBasicInfo));
    }

    updateEmail(userBasicInfo: UserBasicInfo): Promise<UserBasicInfo> {
        return lastValueFrom(this.httpClient.put<UserBasicInfo>(`${this.baseUrl}/email`, userBasicInfo));
    }

    public confirmChangeEmail(token: string): Promise<UserBasicInfo> {
        return lastValueFrom(this.httpClient.put<UserBasicInfo>(`${this.baseUrl}/emailChangeConfirmation`, token));
    }

    getUserById(userId: number): Promise<User> {
        return lastValueFrom(this.httpClient.get<User>(`${this.baseUrl}/${userId}`));
    }

  /**********************************************
  loginOauth2User(chanel: string): Observable<UserInfo> {
    const url: string = window.location.href = (environment.backendAddress + environment.oauth2baseUri +
      (chanel === 'facebook' ? environment.oauth2Facebook : environment.oauth2Google) + environment.oauth2RedirectUri);
    return this.httpClient.get<UserInfo>(url);
  }
  **********************************************/


/************************************************************
  loginUser(user: User): Observable<boolean> {
    console.log("I'm in AuthService - LoginUser()");
    let loginSuccess: Observable<boolean>;
    loginSuccess = this.httpClient.post<UserAuth>(`${this.baseUrl}/signin`, user).pipe(map( data => {
      this.sessionStorage.set('authToken', data.authToken);
      this.sessionStorage.set('authUsername', data.username);
      if (data.authToken.length > 0 && data.username.length > 0) {
        return true;
      } else {
        return false;
      }
    }), catchError( err => {
      return this.errorHandler.handleError(err);
      //console.log("ERROR: " + error.message);
      //return new Observable<boolean>();
    }));
    return loginSuccess;
  }
  *********************************************************/

    getUserIdByEmail(email: string): Observable<number> {
        return this.httpClient.get<number>(`${this.baseUrl}/useridByEmail`, {
        params: {'email': email.toString()}, responseType: 'text' as 'json'});
    }

    emailAllreadyExists(email: string): Observable<any> {
        return this.httpClient.get<boolean>(`${this.baseUrl}/email/${email}`, {
        params: {'email': email.toString()},
        responseType : "boolean" as "json"}).pipe(catchError((err) => {
            return this.errorHandler.handleError(err, "AuthService");
        }));
    }

    nicknameAllreadyExists(nickname: string): Observable<any> {
        return this.httpClient.get<boolean>(`${this.baseUrl}/nickname/${nickname}`, {
        params: {'nickname': nickname.toString()},
        responseType : "boolean" as "json"
        }).pipe(catchError((err) => {
            return this.errorHandler.handleError(err, "AuthService");
        }));
    }

    verifyTokenCheck(token: string): Promise<UserBasicInfo> {
        return lastValueFrom(this.httpClient.get<UserBasicInfo>(`${this.baseUrl}/tokenCheck`, {params: {'token': token}}));
/***************************
            return new Promise<TokenCheck>( (resolve, reject) => {
            lastValueFrom(this.httpClient.post<TokenCheck>(`${this.baseUrl}/verifyTokenCheck`, token)).then( (data: TokenCheck) => {
                if (data) {
                    resolve(data);
                } else {
                    resolve(null);
                }
            });
        });
*****************************/
    }

/*********
    public isAuthenticated(): boolean {
        return this.cookieService.isAuthenticated();
    }
 ********/

    public getUserAuthNickname(): string | undefined {
        return this.cookieService.getClientUserNickname();
    }

    public getTokenOutsiderInfoList(): Observable<GetTokenOutsiderInfoResponse> {
        return this.httpClient.get<GetTokenOutsiderInfoResponse>(`${this.baseUrl}/tokenOutsiderInfo`).pipe(catchError( error => {
            this.errorHandler.handleError(error, "AuthService.getTokenOutsiderInfoList()");
            return of(null);
        }));
    }

    public activateMail(token: string): Observable<string> {
        return this.httpClient.post<string>(`${this.baseUrl}/confirmEmail`, token).pipe(catchError( error => {
            return this.errorHandler.handleError(error, "AuthService.getTokenOutsiderInfoList()");
        }));
    }
/************************ FACEBOOK - INIT *******************************

  public facebookLogin(): Observable<any> {
    return from(new Promise<fb.StatusResponse>(resolve => FB.login(resolve))).
    pipe(concatMap(({authResponse}) => {
      if(! authResponse) {return EMPTY}
      return of(authResponse);
    }));
  }

/************************ FACEBOOK - END ********************************/
}

interface GetTokenOutsiderInfoResponse {
    _embedded: {
        tokenOutsiderInfoRepresentationList: Set<TokenOutsiderInfo>;
    },
    _links: {
        all: {
            href: string
        }
    }
}



/*****************************************************************************
 * 
interface GetFacebookStatus {
  status: string,
  authResponse: {
    accessToken: string,
    expiresIn: string,
    reauthorize_required_in: string,
    signedRequest: string,
    userID: string
  }
}
 * 
 *
 * HANDLING DIFFERENT ERROR STATUS SAMPLE
 * --------------------------------------
 *switch (error.status) {
 *  case 404: {
 *    return `Not Found: ${error.message}`;
 *  }
 *  case 403: {
 *    return `Access Denied: ${error.message}`;
 *  }
 *  case 500: {
 *    return `Internal Server Error: ${error.message}`;
 *  }
 *  default: {
 *    return `Unknown Server Error: ${error.message}`;
 *  }
 *}
 * 
 *****************************************************************************/